import loadable from '@loadable/component';
import expertToplistQuery from './query.graphql';

const ExpertToplists = loadable(() =>
  import(/* webpackChunkName: "expert" */ './toplists')
);

ExpertToplists.graphQL = expertToplistQuery;

ExpertToplists.variables = ({ slug }) => ({
  slug,
});

export default ExpertToplists;
